import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {replaceItem} from '../../common/util/array';

const INITIAL_STATE = {
  'loading': false,
  'sequentialType': '',
  'sequentialName': '',
  'abbreviation': '',
  'configValues': [],
};

const updateConfigValues = (configValues, parameter) => {
  const currentIndex = configValues.findIndex(
    (value) =>
      value.sequentialType === parameter.sequentialType &&
      value.sequentialName === parameter.sequentialName
  );

  if (currentIndex !== -1) {
    return replaceItem(configValues, currentIndex, parameter);
  }

  return [parameter, ...configValues];
};

const findAbbreviation = (list, type, name) => {
  const parameter = list.find(
    (parameter) =>
      parameter.sequentialName === name || parameter.sequentialType === type
  );

  return parameter ? parameter.abbreviation : '';
};

export const providerSequenceConfig = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CHANGE_PROVIDER_ORDER_SEQUENCE_PARAMETER]: (
      state,
      action
    ) => ({
      ...state,
      [action.payload.field]: action.payload.value,
    }),
    [ActionTypes.FIND_ABBREVIATION_BY_TYPE_AND_NAME]: (state, action) => ({
      ...state,
      'abbreviation': findAbbreviation(
        state.configValues,
        state.type,
        action.payload
      ),
    }),
    [ActionTypes.SELECT_PROVIDER_ORDER_ABBREVIATION]: (state, action) => ({
      ...state,
      'sequentialType': action.payload.sequentialType,
      'sequentialName': action.payload.sequentialName,
      'abbreviation': action.payload.abbreviation,
    }),
    [ActionTypes.LOAD_PROVIDER_ORDER_ABBREVIATIONS_REQUEST]: (
      state,
      action
    ) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.LOAD_PROVIDER_ORDER_ABBREVIATIONS_SUCCESS]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
      'configValues': action.response.json,
    }),
    [ActionTypes.LOAD_PROVIDER_ORDER_ABBREVIATIONS_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
      'configValues': [],
    }),
    [ActionTypes.SAVE_PROVIDER_ORDER_ABBREVIATIONS_REQUEST]: (
      state,
      action
    ) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.SAVE_PROVIDER_ORDER_ABBREVIATIONS_SUCCESS]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
      'sequentialType': '',
      'sequentialName': '',
      'abbreviation': '',
      'configValues': updateConfigValues(state.configValues, action.payload),
    }),
    [ActionTypes.SAVE_PROVIDER_ORDER_ABBREVIATIONS_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
